import pathToRegexp from 'path-to-regexp'

export const handleVariable = function (param) {
  const letter = param.toLowerCase()
  const arr = letter.split('_')
  if (arr.length > 1) {
    let result = ''
    arr.forEach((item, index) => {
      result += index ? `${item[0].toUpperCase()}${item.slice(1)}` : item
    })
    return result
  } else {
    return param ? param[0].toLowerCase() + param.slice(1) : ''
  }
}

export function isWeixinBrowser () {
  return /micromessenger/.test(navigator.userAgent.toLowerCase())
}

export function urlMatchPattern (url, pattern) {
  const re = pathToRegexp(pattern)
  return re.test(url)
}

/**
 * @template T
 * @param {Promise<T>} promise
 * @returns {Promise<[null, T] | [Error, null]>}
 */
export function wrapAwait (promise) {
  return promise.then(data => /** @type {[null, T]} */([null, data])).catch(err => /** @type {[Error, null]} */([err, null]))
}

export function resolveState ({ errors, pending, valid }) {
  if (errors[0]) {
    return 'error'
  }
  if (pending) {
    return 'validating'
  }

  if (valid) {
    return 'success'
  }

  return ''
}

export function omit (obj, ...omitKeys) {
  const res = {}
  for (const key in obj) {
    if (!omitKeys.includes(key)) {
      res[key] = obj[key]
    }
  }
  return res
}

export function nullIfEmpty (x) {
  if (x == null) return null
  if (Object.keys(x).length === 0) return null
  return x
}
